import { FC, useRef, useState } from "react";
import { useUserStore } from "store/user";
import { getVesselFilter } from "api/vessel";
import CustomDropDownList from "ui/dropDown";
import { useTranslation } from "react-i18next";
import { Vessel } from "interface/vessel";
import { VesselRenderItem } from "ui/dropdownItemList/VesselRenderItem";
import { getUserVessels, VesselDocumentFilterOptions } from "api/vessel";

interface CustomProps {
	setFilterOptions: (options: VesselDocumentFilterOptions) => void;
	filterOptions: VesselDocumentFilterOptions;
	// exportAsExcel: () => void;
}
const Filter: FC<CustomProps> = ({
	setFilterOptions,
	filterOptions,
	// exportAsExcel,
}) => {
	const { t } = useTranslation();
	const { isAdmin, isCompanyAdmin } = useUserStore();
	const [vessels, setVessels] = useState<Vessel[]>([]);

	const handleVessel = (vessel: Vessel) => {
		setFilterOptions({
			...filterOptions,
			vesselId: vessel.id,
			vesselName: vessel.nm,
			vesselRegistrationId: vessel.rn,
		});
	};

	const getvessels = async (text: string = "") => {
		try {
			if (isAdmin) {
				const data = await getVesselFilter(text);

				return data || [];
			}
			if (vessels.length > 0) {
				return vessels;
			}
			const data = await getUserVessels();
			setVessels(data || []);
			return data || [];
		} catch (error) {
			console.error(error);
			return [];
		}
	};

	return (
		<div className="filter-container">
			<div className="filter-items ">
				<div className="settlement-filter-field" style={{ width: "170px" }}>
					<CustomDropDownList
						data={vessels}
						filterable={isAdmin}
						dataItemKey="id"
						textField="nm"
						label={t("Vessel")}
						value={{
							id: filterOptions.vesselId || null,
							nm: filterOptions.vesselName || " ",
						}}
						// label="Velg Fart�y"
						defaultItem={{ id: null, nm: t("All") }}
						onSelect={handleVessel}
						serverFilter={isAdmin}
						getData={getvessels}
						itemRender={VesselRenderItem()}
						serverFilterApi={getvessels}
					/>
				</div>
			</div>

			<div className="filter-end-btn store-statistics-filter-end-btn">
				{/*<CustomButton*/}
				{/*	label={"PDF"}*/}
				{/*	onClick={() => exportAsPDF()}*/}
				{/*	iconName={ICON_NAMES.Download}*/}
				{/*/>*/}
				{/* <CustomButton
					label={"Excel"}
					onClick={() => exportAsExcel()}
					iconName={ICON_NAMES.Download}
				/> */}
			</div>
		</div>
	);
};

export default Filter;
